// globally access application settings,
// example: this.getApplicationSetting('...') === '1'
// example: v-if="getApplicationSetting('...') === '1'"
export default {
  computed: {
    applicationSettings () {
      return this.$store.getters.applicationSettings
    },
    getApplicationSetting () {
      return (name) => {
        return this.$store.getters.applicationSetting(name);
      }
    }
  }
}
